// getters.js

export default {
    getSitesList(state){
        return state.sitesList
    },
    getCurrentSite(state){
        return state.currentSite
    },
    getSiteNameById: (state) => (id) => {
        let site = state.sitesList.find(item=>item.id === id)
        if(site){
            return site.name
        } else {
            return 'Не указано'
        }
    },
    getCurrentTimeZone(state){
        return state.timeZone
    }
};
